import { render, staticRenderFns } from "./paymentFail.vue?vue&type=template&id=ff69cd1a&scoped=true"
import script from "./paymentFail.vue?vue&type=script&lang=js"
export * from "./paymentFail.vue?vue&type=script&lang=js"
import style0 from "./paymentFail.vue?vue&type=style&index=0&id=ff69cd1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff69cd1a",
  null
  
)

export default component.exports